export const CONSOLE_URL_US = process.env.NODE_ENV === 'development' ? 'https://play-cloud-us.herokuapp.com/' : 'https://play-cloud-us.herokuapp.com/'
export const CONSOLE_URL_EU = 'https://play-cloud.com/api/'
export const CONSOLE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : CONSOLE_URL_EU
export const DEEP_LINK_ANDROID = 'playcloudconsole://mylink'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.playcloud.console'
export const APP_STORE_URL = 'https://apps.apple.com/us/app/playcloud-gaming-console/id6477292757'
export const CDN_URL = 'https://d3f3jwzc44jpop.cloudfront.net'
